import { render } from "./TextoMalibu.vue?vue&type=template&id=287f5ba0&scoped=true"
import script from "./TextoMalibu.vue?vue&type=script&lang=js"
export * from "./TextoMalibu.vue?vue&type=script&lang=js"

import "./TextoMalibu.vue?vue&type=style&index=0&id=287f5ba0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287f5ba0"]])

export default __exports__